import React from "react"
import {
  Window,
  View,
  Text,
  Hint,
  Input,
  Grid,
  Col,
} from "react-ame-components"

export class HintExample extends React.Component {
  state = {
    inputValue: "",
    hintMessage: "",
    showHint: false,
    typeHint: "",
  }

  getInputValue = text => {
    this.setState({ inputValue: text })
    if (text.length < 8) {
      this.setState({ hintMessage: "O texto deve ter mais de 8 caracteres." })
      this.setState({ showHint: true })
      this.setState({ typeHint: "error" })
    } else if (text.length > 13) {
      this.setState({ hintMessage: "O texto está muito grande." })
      this.setState({ typeHint: "warning" })
    } else {
      this.setState({ hintMessage: "O texto passou no teste." })
      this.setState({ typeHint: "success" })
    }
  }
  render() {
    return (
      <Window>
        <View
          direction="column"
          align="center"
          justify="center"
          marginTop="big">
          <Grid>
            <Col columnSize={{ sm: 1, md: 3 }}></Col>
            <Col columnSize={{ sm: 10, md: 6 }}>
              <View
                backgroundColor="neutral-100"
                padding="big"
                borderRadius="small"
                shadow="level-2"
                direction="column"
                align="center">
                <Text
                  fontSize="large"
                  lineHeight="large"
                  fontWeight="bold">
                  Componente [color=primary]Hint[/color]
                </Text>
                <Text>Este componente serve para exibir um Hint</Text>
                <View margin="small">
                  <View marginTop="large">
                    <Input
                      placeholder="Teste Hint"
                      value={this.state.inputValue}
                      onChange={e => this.getInputValue(e)}
                    />
                    <Hint
                      show={this.state.showHint}
                      type={this.state.typeHint}>
                      {this.state.hintMessage}
                    </Hint>
                  </View>
                </View>
              </View>
            </Col>
            <Col columnSize={{ sm: 1, md: 3 }}></Col>
          </Grid>
        </View>
      </Window>
    )
  }
}
